import { EquipmentType } from '@racepointenergy/swc/scs/features/host-equipment'
import { useIntl } from 'react-intl'

import { DASH_SYMBOL } from 'app/consts'
import { homeDeviceInformationMessages as messages } from '../../messages'
import DeviceWhiteCardSection from '../../components/DeviceWhiteCardSection'
import { equipmentTypes } from '../../consts'
import { EquipmentComponentProps } from '../../types'

const CommonIPAddressComponent = ({ equipment }: EquipmentComponentProps) => {
  const { formatMessage } = useIntl()

  const value = equipment?.IPAddress || equipment?.Hostname || DASH_SYMBOL

  return (
    <DeviceWhiteCardSection
      title={formatMessage(messages.deviceIPAddress)}
      value={value}
    />
  )
}

const equipmentIPAddressComponents = {
  [equipmentTypes[EquipmentType.Components]]: CommonIPAddressComponent,
  [equipmentTypes[EquipmentType.Chassis]]: CommonIPAddressComponent,
  [equipmentTypes[EquipmentType.UncontrollableComponents]]: () => null, // always disconnected
  [equipmentTypes[EquipmentType.MobileDevices]]: () => null, // not yet supported
  [equipmentTypes[EquipmentType.Hosts]]: () => null, // always disconnected
}

function EquipmentIPAddress({ equipment }: EquipmentComponentProps) {
  const {
    [equipment?.StatusPathParts?.type || '']: EquipmentIPAddressComponent,
  } = equipmentIPAddressComponents

  if (EquipmentIPAddressComponent) {
    return <EquipmentIPAddressComponent equipment={equipment} />
  }

  return null
}

export default EquipmentIPAddress
